<template>
    <div v-if="showOverlay" id="sidebar-overlay"></div>
</template>
<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'


import { EventBus } from '@/models/event-bus'

export default defineComponent({
    name: 'OverlayComponent',
    setup() {
        const showOverlay = ref(false)

        onMounted(() => {
            EventBus.$on('closeOverlay', () => {
                showOverlay.value = false
            })
            EventBus.$on('openOverlay', () => {
                showOverlay.value = true
            })
        })

        onUnmounted(() => {
            EventBus.$off('closeOverlay')
            EventBus.$off('openOverlay')
        })

        return {
            showOverlay
        }
    }
})
</script>
<style scoped>
#sidebar-overlay {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100vh;
    z-index: 40;
    background: gray;
    opacity: 0.5;
}
</style>